import { Box } from '@chakra-ui/react';
import Layout from '../common/Layout';
import { Outlet } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';

const JobFeed = () => {
  useRole(['support', 'marketing']);
  return (
    <Box data-test-id="pact-job-feed">
      <Layout pageTitle={'Pact'}>
        <Outlet />
      </Layout>
    </Box>
  );
};

export default JobFeed;
